export const NOTE_VARIANT = {
  DEFAULT: 'default',
  ALTERNATIVE: 'alternative'
} as const;
